import { KeyboardEvent, useCallback, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import cn from 'utils/cn'
import { FundingModalFormValues } from 'core/widgets/funding-modal/FundingModal'
import SmartField from 'core/components/form/SmartField'
import Input from 'core/components/inputs/Input'
import EditAmountRadio from 'core/widgets/funding-modal/edit-amount/EditAmountRadio'

interface Props {
  className?: string
}

const OtherAmountType = ({ className }: Props) => {
  const { control, watch, setValue } = useFormContext<FundingModalFormValues>()

  const [amountType, enterAmountMode, customAmount] = watch([
    'amountType',
    'enterAmountMode',
    'customAmount'
  ])
  const formAmount = customAmount ?? 0
  const amountNumber = formAmount
    ? parseFloat(formAmount?.replaceAll(/(\$|,)/g, ''))
    : 0

  const value = 'other-amount' as FundingModalFormValues['amountType']

  const onAmountKeyUp = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Escape') {
        setValue('enterAmountMode', false)
      }
    },
    [setValue]
  )

  const onEnterAmountClick = useCallback(() => {
    setValue('enterAmountMode', true)
  }, [setValue])

  useEffect(() => {
    const customAmountInput = document.querySelector(
      '#funding-modal-custom-amount'
    ) as HTMLInputElement | null
    if (amountType === 'other-amount' && enterAmountMode && customAmountInput) {
      customAmountInput.focus()
    }
  }, [amountType, enterAmountMode])

  return (
    <EditAmountRadio
      className={className}
      value={value}
      label={
        <div className="w-full flex justify-between items-center">
          <label htmlFor={value} className="font-semibold cursor-pointer">
            Other amount
          </label>
          {amountType === 'other-amount' &&
            (enterAmountMode ? (
              <SmartField
                controllerProps={{
                  control,
                  name: 'customAmount',
                  rules: {
                    required: 'Specify the amount',
                    validate: (value) => {
                      return value !== '$0.00' || `Specify the amount`
                    }
                  }
                }}
                label=""
                className="mb-0!"
              >
                <Input
                  id="funding-modal-custom-amount"
                  className={cn([
                    'border-transparent! outline-hidden! bg-transparent! [&_input]:text-right',
                    amountNumber < 0 && 'text-danger',
                    amountNumber === 0 && 'text-dark-3'
                  ])}
                  type="money"
                  placeholder="$0.00"
                  onKeyUp={onAmountKeyUp}
                />
              </SmartField>
            ) : (
              <span
                className="text-primary cursor-pointer font-semibold"
                onClick={onEnterAmountClick}
              >
                Enter amount
              </span>
            ))}
        </div>
      }
    />
  )
}

export default OtherAmountType
